module.exports = __webpack_public_path__ + "static/media/track_icon.19d771fb.png";